var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.props.tag,_vm._g({tag:"component",staticClass:"rmp-text",class:`rmp-text--${_setup.textToken}`,style:({ color: _vm.color, fontWeight: _setup.textWeight, fontFamily: _setup.textFont })},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }